var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"inscribe"},[_c('div',{staticClass:"hotline"},[_vm._v(" 本服务由谷城县供水总公司提供"),_c('br'),_vm._v("24小时便民服务热线：0710-7246327 "),_c('br'),_c('a',{attrs:{"href":"https://beian.miit.gov.cn"}},[_vm._v("鄂ICP备2023019298号")])])])
}]

export { render, staticRenderFns }